var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-file-v2" }, [
    _c("div", { staticClass: "upload-box" }, [
      _c("div", { staticClass: "upload-box-main" }, [
        _c(
          "div",
          {
            staticClass: "drop-area",
            class: { "drop-area-dragging": _vm.dragging && !_vm.disabled },
            on: {
              ondragover: _vm.onChangeFile,
              dragenter: function($event) {
                _vm.dragging = true
              },
              dragend: function($event) {
                _vm.dragging = false
              },
              dragleave: function($event) {
                _vm.dragging = false
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "drop-area-texts d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "span",
                  { staticClass: "text-heading-small text-color-900" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dragging
                            ? "Solte para importar"
                            : (_vm.value || {}).name || _vm.label
                        ) +
                        " "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    !_vm.value && _vm.append.icon
                      ? _c("icon-svg", {
                          staticClass: "mr-2",
                          attrs: { name: _vm.append.icon, color: "primary" }
                        })
                      : _vm._e(),
                    !_vm.value
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "text-primary text-subtitle-small font-general-sans"
                          },
                          [_vm._v(" " + _vm._s(_vm.append.text) + " ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.value
                  ? _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticStyle: { "z-index": "2" },
                            attrs: {
                              icon: "",
                              small: "",
                              disabled: _vm.disabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.clear({ emit: true })
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v(" mdi-close ")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            !_vm.disabled
              ? _c("input", {
                  ref: "input",
                  attrs: {
                    id: _vm.idInput,
                    type: "file",
                    name: _vm.idInput,
                    required: "",
                    accept: _vm.types.join(", "),
                    disabled: _vm.disabled,
                    readonly: _vm.disabled,
                    multiple: _vm.multiple
                  },
                  on: { change: _vm.onChangeFile }
                })
              : _vm._e(),
            _vm._t("default")
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }